<div [formGroup]="group">

  <app-formelementinputlabel
    [config]="config"
    [group]="group">
  </app-formelementinputlabel>

  <app-inner-label [formControlName]="config.name"
                   [config]="config"
                   [group]="group">
  </app-inner-label>

  <app-formelementinputdescription
    [config]="config"
    [group]="group">
  </app-formelementinputdescription>

</div>
